import Container from "./components/Container";
import Navbar from "./components/Navbar";
import Navigation from "./navigation/Navigation";

function App() {
  return (
    <>
      <div className="App">
        <Navigation />
      </div>
    </>
  );
}

export default App;
